import isEqual from 'lodash/isEqual'
import pick from 'lodash/pick'
import values from 'lodash/values'
import { AnySourceStream, Stream } from '../stream'

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        distinctUntilChangedProps(...props: (keyof DV)[]): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.distinctUntilChangedProps = function <V, E, C>(this: AnySourceStream<V, E, C>, ...props: (keyof V)[]) {
    return this.distinctUntilChanged((obj) => values(pick(obj, props)), isEqual)
}
